export default __webpack_public_path__ + "static/media/datadyst-logo.d824e644.svg";